var YouboraObject = require('../object')
var Log = require('../log')

/**
 * This static class provides information about the load times of the page
 *
 * @constructs YouboraObject
 * @extends youbora.YouboraObject
 * @memberof youbora
 *
 */
var BrowserLoadTimes = YouboraObject.extend({
  constructor: function () {
    this.timeObject = null
    this.playerSetup = null
    if (typeof window !== 'undefined' && window.performance && window.performance.timing) {
      this.timeObject = window.performance.timing
    } else {
      Log.notice('Load time metrics not available')
    }
  },

  getPageLoadTime: function () {
    var ret = null
    if (this.timeObject) {
      ret = this.timeObject.domContentLoadedEventEnd - this.timeObject.navigationStart
    }
    return ret
  },

  getPlayerStartupTime: function () {
    var ret = null
    if (this.timeObject && this.playerSetup) {
      ret = this.playerSetup - this.timeObject.navigationStart
    }
    return ret
  },

  setPlayerSetupTime: function () {
    this.playerSetup = this.playerSetup || new Date().getTime()
  }
})

module.exports = BrowserLoadTimes
